import React from 'react'
import Heading from 'utils/Heading'
import RichText from 'utils/RichText'

const IntroTypeWide = ({blok}) => {
    return (
        <div className="my-12 lg:my-24">
            <div className="mx-auto px-6 lg:px-12 max-w-7xl mx-auto">
                <div class="block lg:flex lg:flex-row gap-10">
                    <div className='w-full lg:w-2/3'>
                        <Heading size="h3" className="!text-4xl lg:!text-[64px] lg:!leading-[4.5rem]">
                            {blok.title}
                        </Heading>
                    </div>
                </div>
                {blok.content &&
                    <div className='grid grid-cols-3 mt-10 lg:mt-16'>
                        <div className='col-start-1 lg:col-start-2 col-span-3 lg:col-span-2'>
                            <RichText>
                                {blok.content}
                            </RichText>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
};

export default IntroTypeWide;